// extracted by mini-css-extract-plugin
export default {"adTabs":"AdTabs_adTabs__UaVPv"};